module.exports = "/_next/static/images/cabs-service-4-9ed8fcfec080bcd7d13d14e11098e425.webp";